import script from "./BookingHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingHistory.vue?vue&type=script&setup=true&lang=ts"

import "./BookingHistory.vue?vue&type=style&index=0&id=68a09eaa&scoped=true&lang=scss"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a09eaa"]])

export default __exports__